// Centralized CMS tour endpoints used by create/read/update flows.
const toursEndpoints = {
  // Collection endpoint.
  base: '/v1/cms/tours',
  // Single entity endpoint.
  byId: (id) => `/v1/cms/tours/${id}`
};

export default toursEndpoints;
